export class TeamMember {

  user_id: number
  name: string
  email: string
  phone: string

  constructor(data: any = {}) {
    this.user_id = data.user_id
    this.name = data.name
    this.email = data.email
    this.phone = data.phone
  }

  get link(): any[] {
    return ['/finance/users', this.user_id]
  }

  get addTranLink(): string {
    return `/finance/users/${this.user_id}/add-tran`
  }

}



// WEBPACK FOOTER //
// ./src/app/models/user/team-member.ts